import React, { useEffect, useState } from "react";
import { mergeRight } from "ramda";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { lensProp, pick, set } from "ramda";
import Grid from "@material-ui/core/Grid";
import { FetchError } from "../../../util/fetchUtils";
import { useDispatch } from "react-redux";
import { logOut } from "../../../auth/authActions";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useSftpAccountUpdate } from "../sftpAccountServices";

const Alert = React.forwardRef((props, ref) => {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const initialState = {
  fields: {
    password: "",
    confirmPassword: "",
  },
};

const SftpAccountPasswordUpdate = ({ account, open, onClose, onSave }) => {
  const dispatch = useDispatch();
  const [fields, setFields] = useState(initialState.fields);
  const [errorAlert, setErrorAlert] = useState({ open: false });

  useEffect(() => {
    if (account && account.sftpAccountId) {
      setFields(pick(["password"], account));
    } else {
      setFields(initialState.fields);
    }
  }, [account]);

  const onFieldChanged = field => (event, optVal) => {
    const value = event.target.value || optVal;
    const update = set(lensProp(field), value, fields);
    setFields(update);
  };

  const showAlert = message =>
    setErrorAlert({
      open: true,
      message,
    });

  const accountUpdate = useSftpAccountUpdate();
  const handleError = message => err => {
    if (err instanceof FetchError) {
      if (err.status === 401) {
        dispatch(logOut());
      } else {
        showAlert(message);
      }
    } else {
      showAlert(err.message);
    }
  };

  const handleOnSave = async () => {
    const mergedAccount = mergeRight(account, fields);
    if (mergedAccount.password === mergedAccount.confirmPassword) {
      try {
        await accountUpdate.mutateAsync({
          resourceIds: { sftpAccountId: mergedAccount.sftpAccountId },
          data: mergedAccount,
        });

        onSave(mergedAccount);
      } catch (err) {
        handleError("Unable to update Account Password.");
      }
    } else {
      showAlert("Confirm Password does not match.");
    }
  };

  const handleOnClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleOnClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        SFTP Account ({account.sftpAccountId})
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Update Account Password.</DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              autoFocus
              id="password"
              label="Password"
              type="password"
              fullWidth
              value={fields.password || ""}
              onChange={onFieldChanged("password")}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="confirmPassword"
              label="Confirm Password"
              type="password"
              fullWidth
              value={fields.confirmPassword || ""}
              onChange={onFieldChanged("confirmPassword")}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOnSave} color="primary">
          Save
        </Button>
      </DialogActions>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlert.open}
        autoHideDuration={6000}
        onClose={() => setErrorAlert(mergeRight(errorAlert, { open: false }))}
      >
        <Alert
          onClose={() => setErrorAlert(mergeRight(errorAlert, { open: false }))}
          severity="error"
        >
          {errorAlert.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default SftpAccountPasswordUpdate;
